'use client'

import { SessionProvider } from 'next-auth/react'
import { Toaster } from 'sonner'
import { BrandingProvider } from '@/components/branding-provider'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider refetchOnWindowFocus refetchInterval={5 * 60}>
      <BrandingProvider>
        {children}
        <Toaster richColors position="top-right" />
      </BrandingProvider>
    </SessionProvider>
  )
}
